<template>
  <div>
    <div v-if="datosSesion.idPerfil===6">
      <InicioDocente :datosSesion="datosSesion"/>
    </div>
    <div v-else-if="datosSesion.idPerfil===7">
      <InicioEstudiante :datosSesion="datosSesion"/>
    </div>
    <div v-else>
      <InicioPrincipal :datosSesion="datosSesion"/>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import InicioDocente from '@/components/inicio/InicioDocente'
  import InicioEstudiante from '@/components/inicio/InicioEstudiante'
  import InicioPrincipal from '@/components/inicio/InicioPrincipal'

  export default {
    name: 'Home',
    components: {
      InicioDocente,
      InicioEstudiante,
      InicioPrincipal
    },
    computed: {
      ...mapState(['datosSesion'])
    }
}
</script>
